<template>
  <div>
    <v-select
      :items="items"
      clearable
      :multiple='multiple'
      :label="label"
      v-model="userIds"
      item-text="name"
      :item-value="mid ? 'mdUserId' : 'id'"
      outlined
      hide-details='auto'
      @input="idChange"
      v-bind="$attrs"
    >
    <template v-slot:selection="{ item, index }">
        <v-chip small v-if="index === 0" color='primary'>
          <span>{{ item.name }}</span>
        </v-chip>
        <span
          v-if="index === 1"
          class="grey--text text-caption"
        >
          (+{{ userIds.length - 1 }} 其他人)
        </span>
      </template>
      <template v-slot:prepend-item>
        <div>
           <v-text-field
              dense
              outlined
              hide-details
              label="输入姓名搜索"
              v-model="form.name"
              class="mx-3"
              autocomplete="off"
              ref="search"
              @input="inputValue"
            >
            <!-- <template v-slot:append>
              <v-btn :loading='loading' fab x-small color="primary" @click='loadData' class="mt-n1 mr-n2">
                <v-icon dark>mdi-magnify</v-icon>
              </v-btn>
            </template> -->
          </v-text-field>
          <v-divider class="mt-2"></v-divider>
        </div>
      </template>
    </v-select>
 </div>
</template>

<script>
  import { getByMid } from '@/api/system/user.js'
  import { isEmpty } from '@/utils/stringUtil.js'

  export default {
    name: 'MarerialDeptSelect',
    components: {
    },
    props: {
      value: {
        type: [Number, Array, String]
      },
      menu: {
        type: Number,
        required: false
      },
      label: {
        type: String,
        default: '用户选择'
      },
      mid: { // 是否返回加密后的userid md_user_id
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        items: [],
        userIds: this.value,
        loading: false,
        form: {
          mid: this.menu,
          name: ''
        }
      }
    },
    methods: {
      idChange (val) {
        this.$emit('input', val)
      },
      inputValue (val) {
        if (isEmpty(val)) {
          this.items = this.result
        } else {
          const searchName = []
          this.result.forEach((user) => {
            if (user.name.indexOf(val) !== -1) {
              searchName.push(user)
            }
          })
          this.items = searchName
        }
      },
      loadData () {
        this.items = []
        this.loading = true
        getByMid(this.form).then(res => {
          if (res.status === 200) {
            this.items = res.data
            this.result = res.data
          }
          this.loading = false
        })
      }
    },
    watch: {
      value (ne) {
        this.userIds = ne
      }
    },
    created() {
      this.loadData()
    }
  }
</script>

<style >
  .v-input__append-outer{
    margin-top: -3px !important;
  }
  .chip-dom {
    border: 1px solid #e0e0e0;
    height: 80px;
    padding: 5px;
    margin: 5px 7px 0 7px;
    border-radius: 3px;
    overflow: auto;
  }
</style>
